import React from 'react';
import { useEffect, useState, useRef } from 'react';
import modifica from '../imgs/icons/modifica.svg';
import confirmW from '../imgs/icons/confirmW.svg';
import close from '../imgs/icons/close.svg';

const defContinua = "selettore selettoreFlex selettoreBlue";

const PopupBottomButtons = ({mod, setMod, status, alertInput, salvaModifiche, bedroomlayoutCenterX, latestType4, presence, sensorMounting}) => {

  const [flashColor, setFlashColor] = useState(false);
  const previousValue = useRef(null);

  useEffect(() => {
    if (latestType4 && latestType4 !== previousValue.current) {
      setFlashColor(true);

      const timer = setTimeout(() => {
        setFlashColor(false);
      }, 5000);

      previousValue.current = latestType4;

      return () => clearTimeout(timer); // clean up on new change
    }
  }, [latestType4]);

  const color = flashColor ? 'green' : 'blue';

  return (
      <div className="edit-container" style={{ padding: "0px" }}>
          {mod === 0
              ? <div
                  className="selettore selettoreFlex selettoreViolet"
                  onClick={() => setMod(1)}
              >
                  <p>Modifica</p>
                  <img src={modifica} alt='modifica' style={{ width: "1em" }} />
              </div>
              : <>
                  {!alertInput ?
                      <div
                          className={defContinua}
                          onClick={() => salvaModifiche()}
                      >
                          <p>Salva</p>
                          <img src={confirmW} alt='confirmW' />
                      </div>
                      : null}
                  <div className="selettore selettoreFlex selettoreViolet"
                      onClick={async () => {
                          setMod(0);
                      }}
                  >
                      <p>Annulla</p>
                      <img src={close} alt="close" />
                  </div>
              </>

          }
          {(bedroomlayoutCenterX && (status === 1)) && (
              <div
                  style={{
                      position: 'absolute',
                      marginTop: '-20px',
                      left: `${bedroomlayoutCenterX-10}px`,
                      transform: 'translateX(-50%)',
                      whiteSpace: 'nowrap',
                      color: 'blue',
                      padding: '0.2em 0.5em',
                      zIndex: 10,
                  }}
              >
                  {sensorMounting === 2 ? 'Y-MIN' : 'Y-MAX'}
              </div>
          )}
          {(latestType4 && bedroomlayoutCenterX && (status === 1)) && (
              <div
                  style={{
                      position: 'absolute',
                      marginTop: '-20px',
                      left: `${bedroomlayoutCenterX + 200}px`,
                      transform: 'translateX(-50%)',
                      whiteSpace: 'nowrap',
                      color: color,
                      padding: '0.2em 0.5em',
                      zIndex: 10,
                  }}
              >
                  {presence && (
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 -4 24 24"
                          width="24"  // Size of the icon
                          height="24" // Size of the icon
                          style={{ marginRight: '5px' }}
                      >
                          {/* Head */}
                          <circle cx="12" cy="6" r="4" style={{ fill: color }} />

                          {/* Body */}
                          <line x1="12" y1="10" x2="12" y2="16" style={{ stroke: color, strokeWidth: 2 }} /> {/* Body */}

                          {/* Arms */}
                          <line x1="8" y1="12" x2="16" y2="12" style={{ stroke: color, strokeWidth: 2 }} /> {/* Arms */}

                          {/* Legs */}
                          <line x1="12" y1="16" x2="8" y2="20" style={{ stroke: color, strokeWidth: 2 }} /> {/* Left Leg */}
                          <line x1="12" y1="16" x2="16" y2="20" style={{ stroke: color, strokeWidth: 2 }} /> {/* Right Leg */}
                      </svg>
                  )}
                  {latestType4}
              </div>
          )}
      </div>
  );
};

export default PopupBottomButtons;
